import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { cartItemDispatchers as dispatchers } from 'reduxModules/cart/dispatchers'
import NumericInput from './NumericInput'
import utils from '../../../utils/cartItemUtils'
import math from '../../../../redux/modules/utils/math'
import './styles.css'

export class CartItem extends Component {
  renderDesktop() {
    const { props } = this
    const hasSubscribeDiscount = props.price !== props.regularPrice
    return (
      <div className="cart-item">
        <div className="thumbnail">
          {props.type !== 'plan' && (
            <img alt="Cart item image" src={props.thumbnail.cartThumb} />
          )}
          {props.type === 'plan' && (
            <div className="plan-icon">
              <i className={`icon-monster-${props.ordered.rank}`} />
            </div>
          )}
        </div>
        <div className="description">
          <div className="type blue">
            <span>{utils.getNaturalType(props.orderedModel, props.ordered)}</span>
          </div>
          <div className="title">
            <span>{utils.getTitle(props.orderedModel, props.ordered)}</span>
          </div>
          <div className="extra">
            {props.orderedModel === 'path' && (
              <span>{`${props.ordered.numTutorials} courses`}</span>
            )}
          </div>
        </div>
        <div className="price">
          {hasSubscribeDiscount && (
            <span className="subscribe-discount">${math.toFixed(props.regularPrice)}</span>
          )}
          <span>${math.toFixed(props.price)}</span>
          {hasSubscribeDiscount && props.discountPercentage > 0 && (
            <span className="discount-message">
              Subscribers <br /> save {props.discountPercentage}%
            </span>
          )}
        </div>
        <div className="quantity">
          {props.type === 'physical' && (
            <NumericInput
              value={props.quantity}
              id={props.id}
              update={(pk, qt) => props.updateCartItemQuantity(pk, qt)}
              disabled={props.loading > 0}
              remove={(pk) => props.removeCartItemDispatcher(pk)}
            />
          )}
          {props.type !== 'physical' && <span>{props.quantity}</span>}
        </div>
        <div className="subtotal">
          <span>${math.toFixed(parseFloat(props.price * props.quantity))}</span>
        </div>
        <div className="remove-item">
          <div onClick={() => props.removeCartItemDispatcher(props.id)} className="cross"><i className="icon-x" /></div>
        </div>
      </div>
    )
  }

  renderMobile() {
    const { props } = this
    const hasSubscribeDiscount = props.price !== props.regularPrice
    return (
      <div className="cart-item-mobile">
        <div className="thumbnail">
          {props.type !== 'plan' && props.thumbnail.default && (
            <img src={props.thumbnail.default} alt="Cart item" />
          )}
          {!props.thumbnail.default && props.type !== 'plan' && (
            <img src={props.thumbnail.boxThumb} alt="Cart item" />
          )}
          {props.type === 'plan' && (
            <div className="plan-icon">
              <i className={`icon-monster-${props.ordered.rank}`} />
            </div>
          )}
          <div className="remove-item">
            <div onClick={() => props.removeCartItemDispatcher(props.id)} className="cross"><i className="icon-x-hover" /></div>
          </div>
        </div>
        <section className="first-section">
          <div className="description">
            <div className="type blue">
              <span>{utils.getNaturalType(props.orderedModel, props.ordered)}</span>
            </div>
            <div className="title">
              <span>{utils.getTitle(props.orderedModel, props.ordered)}</span>
            </div>
            <div className="quantity">
              <span>Quantity:</span>
              {props.type === 'physical' && (
                <NumericInput
                  value={props.quantity}
                  id={props.id}
                  update={(pk, qt) => props.updateCartItemQuantity(pk, qt)}
                  disabled={props.loading > 0}
                />
              )}
              {props.type !== 'physical' && (
                <div className="static-quantity">
                  <span>{props.quantity}</span>
                </div>
              )}
            </div>
          </div>
          <div className="price">
            {hasSubscribeDiscount && (
              <span className="subscribe-discount">${math.toFixed(props.regularPrice)}</span>
            )}
            <span>${math.toFixed(props.price)}</span>
            {hasSubscribeDiscount && props.discountPercentage > 0 && (
              <span className="discount-message">
                Subscribers <br /> save {props.discountPercentage}%
              </span>
            )}
          </div>
        </section>
      </div>
    )
  }

  render() {
    const { isMobile } = this.props

    if (isMobile) return this.renderMobile()
    return this.renderDesktop()
  }
}

export const cartItemPropTypes = {
  id: PropTypes.number.isRequired,
  ordered: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object
    ])
  ).isRequired,
  price: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  thumbnail: PropTypes.objectOf(PropTypes.string),
  title: PropTypes.string
}

CartItem.propTypes = {
  ...cartItemPropTypes,
  loading: PropTypes.number.isRequired,
  removeCartItemDispatcher: PropTypes.func.isRequired
}

CartItem.defaultProps = {
  title: '',
  loading: 0,
  thumbnail: { thumb: '' }
}

export default connect(
  null,
  dispatchers
)(CartItem)
